var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-sort"},[_c('div',{class:['wrap-icon-sort', 'active'],on:{"click":function($event){return _vm.handleSort(_vm.sortField)}}},[_c('inline-svg',{class:'svg',attrs:{"src":_vm.iconSort}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }